export const contact = {
  hero: {
    title: 'Contact',
    titleHighlight: 'BULKCOM',
    description: 'Connect with our energy specialists to discuss your requirements and discover how we can optimize your energy infrastructure with reliable, cost-effective solutions.'
  },
  info: {
    title: 'Get in Touch',
    subtitle: 'Our team is ready to assist you with your energy needs',
    address: 'Address',
    addressValue: 'Gorkého 129/10, Bratislava – Old Town',
    invoicing: 'Invoicing Address',
    invoicingValue: 'Poštová 3, Bratislava – Old Town 811 06, Slovakia',
    email: 'E-mail'
  },
  form: {
    title: 'Send us a Message',
    subtitle: 'Fill out the form below and we will get back to you within 24 hours',
    name: 'Your Name',
    namePlaceholder: 'John Doe',
    email: 'Your Email',
    emailPlaceholder: 'john@company.com',
    company: 'Your Company',
    companyPlaceholder: 'Company Name (Optional)',
    message: 'Your Message',
    messagePlaceholder: 'Tell us about your energy requirements...',
    charactersRemaining: 'characters remaining',
    submit: 'Send Message',
    sending: 'Sending...',
    successTitle: 'Message Sent Successfully!',
    successMessage: 'Thank you for contacting us. We will get back to you within 24 hours.',
    errorTitle: 'Error Sending Message',
    errorMessage: 'Please try again or contact us directly at office@bulkcomsro.com',
    close: 'Close'
  }
};
